import React, { useState, useEffect } from "react";

const sampleVisas = [
  {
    type: "Tourist",
    country: "United States",
    dateOfIssue: "2024-01-10",
    dateOfExpiry: "2026-01-10",
    status: "Approved",
    applicationId: "VISA12345",
    passportNumber: "P12345678",
    entryType: "Multiple",
    duration: "6 Months",
    approvalDate: "2024-01-15",
    remarks: "No travel restrictions",
  },
  {
    type: "Business",
    country: "Canada",
    dateOfIssue: "2023-05-20",
    dateOfExpiry: "2025-05-20",
    status: "Approved",
    applicationId: "VISA54321",
    passportNumber: "P98765432",
    entryType: "Single",
    duration: "3 Months",
    approvalDate: "2023-05-22",
    remarks: "Work-related visit",
  },
  {
    type: "Student",
    country: "United Kingdom",
    dateOfIssue: "2022-09-15",
    dateOfExpiry: "2027-09-15",
    status: "Active",
    applicationId: "VISA67890",
    passportNumber: "P11223344",
    entryType: "Multiple",
    duration: "5 Years",
    approvalDate: "2022-09-20",
    remarks: "University enrolled",
  },
  {
    type: "Work",
    country: "Australia",
    dateOfIssue: "2023-07-10",
    dateOfExpiry: "2026-07-10",
    status: "Processing",
    applicationId: "VISA99887",
    passportNumber: "P22334455",
    entryType: "Multiple",
    duration: "3 Years",
    approvalDate: "Pending",
    remarks: "Employer-sponsored visa",
  },
  {
    type: "Medical",
    country: "Germany",
    dateOfIssue: "2024-02-01",
    dateOfExpiry: "2024-08-01",
    status: "Approved",
    applicationId: "VISA55667",
    passportNumber: "P33445566",
    entryType: "Single",
    duration: "6 Months",
    approvalDate: "2024-02-05",
    remarks: "Medical treatment approved",
  },
];

const VisaList = () => {
  const [visas, setVisas] = useState([]);
  const [selectedVisa, setSelectedVisa] = useState(null);

  useEffect(() => {
    // Simulating API fetch with sample data
    setVisas(sampleVisas);
  }, []);

  const handleVisaSelect = (visa) => {
    setSelectedVisa(visa);
  };

  return (
    <div className="p-2">
      <h2 className="text-xl font-bold mb-4 text-center">My Visas</h2>

      {selectedVisa ? (
        <VisaDetails visa={selectedVisa} onBack={() => setSelectedVisa(null)} />
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-200 text-gray-700">
                <th className="border p-2">Visa Type</th>
                <th className="border p-2">Country</th>
                <th className="border p-2">Issue Date</th>
                <th className="border p-2">Expiry Date</th>
                <th className="border p-2">Status</th>
                <th className="border p-2">Action</th>
              </tr>
            </thead>
            <tbody>
              {visas.map((visa, index) => (
                <tr key={index} className="text-center border hover:bg-gray-100 transition">
                  <td className="border p-2">{visa.type}</td>
                  <td className="border p-2">{visa.country}</td>
                  <td className="border p-2">{visa.dateOfIssue}</td>
                  <td className="border p-2">{visa.dateOfExpiry}</td>
                  <td
                    className={`border p-2 font-semibold ${
                      visa.status === "Approved" ? "text-green-600" : "text-yellow-600"
                    }`}
                  >
                    {visa.status}
                  </td>
                  <td className="border p-2">
                    <button
                      onClick={() => handleVisaSelect(visa)}
                      className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition w-full sm:w-auto"
                    >
                      View Details
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {visas.length === 0 && <p className="text-center mt-4">No visas found.</p>}
        </div>
      )}
    </div>
  );
};

// Component to display selected visa details
const VisaDetails = ({ visa, onBack }) => {
  return (
    <div className="p-4 border rounded shadow-lg max-w-lg mx-auto bg-gray-600">
      <h3 className="text-lg font-bold mb-2 text-center">Visa Details</h3>
      <div className="space-y-2">
        <p>
          <strong>Visa Type:</strong> {visa.type}
        </p>
        <p>
          <strong>Country:</strong> {visa.country}
        </p>
        <p>
          <strong>Issue Date:</strong> {visa.dateOfIssue}
        </p>
        <p>
          <strong>Expiry Date:</strong> {visa.dateOfExpiry}
        </p>
        <p>
          <strong>Status:</strong>{" "}
          <span
            className={`font-semibold ${
              visa.status === "Approved" ? "text-green-600" : "text-yellow-600"
            }`}
          >
            {visa.status}
          </span>
        </p>
        <p>
          <strong>Application ID:</strong> {visa.applicationId}
        </p>
        <p>
          <strong>Passport Number:</strong> {visa.passportNumber}
        </p>
        <p>
          <strong>Entry Type:</strong> {visa.entryType}
        </p>
        <p>
          <strong>Duration:</strong> {visa.duration}
        </p>
        <p>
          <strong>Approval Date:</strong> {visa.approvalDate}
        </p>
        <p>
          <strong>Remarks:</strong> {visa.remarks}
        </p>
      </div>
      <div className="mt-4 text-center">
        <button
          onClick={onBack}
          className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition"
        >
          Back
        </button>
      </div>
    </div>
  );
};

export default VisaList;
